module.exports = "<body><br><br></body>\r\n\r\n<router-outlet></router-outlet>"